import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useAnalyticsEvents } from '@atlassian/mpac-analytics';
import { useHistory } from '@atlassian/mpac-ui';
import { DynamicTableUtils } from '@atlassian/mpac-utils';
import isEqual from 'lodash/isEqual';
import * as queryString from 'query-string';
import React from 'react';
import { REPORTS_ROWS_PER_PAGE } from '../../../constants/Preferences';
import ErrorMessage from '../Common/ErrorMessage';
import TableTreeWrapper from '../Common/TableTreeWrapper';
import { tableDataAnalyticsConfig } from '../PartnerReports.events';
import { getNewReportPathname, getNewSearch } from '../ReportsFilters/ReportFilters.utils';
import { useTransactionsReports } from './hooks';
import { mapQueryParamsToApiParams } from './TransactionReports.utils';
import { getTransactionsReportsBody, TransactionsReportsHeader } from './TransactionsReportsTableData';
const TransactionsReports = props => {
  const history = useHistory();
  const fireAnalyticsEvent = useAnalyticsEvents();
  const {
    transactionsAPIResponse,
    pending,
    error
  } = useTransactionsReports(props.mpacBaseUrl, props.partnerId, mapQueryParamsToApiParams(props.queryParams), String(REPORTS_ROWS_PER_PAGE));
  const totalCount = transactionsAPIResponse === null || transactionsAPIResponse === void 0 ? void 0 : transactionsAPIResponse.totalCount;
  const rowsPerPage = DynamicTableUtils.getRowsPerPage(totalCount, REPORTS_ROWS_PER_PAGE);
  const offset = props.queryParams.offset || 0;

  // eg: If offset is 10, page number would be 2 (10/10 + 1)
  const pageNum = Number.parseInt(offset.toString(), 10) / rowsPerPage + 1;
  const updateQueryParams = (queryParam, value) => {
    if (history) {
      const queryParams = queryString.parse(history.location.search || '');
      history.push({
        pathname: getNewReportPathname(props.partnerId, props.reportName, false, ''),
        search: getNewSearch(queryParams, queryParam, value)
      });
    }
  };
  const getReportsLink = (queryParam, value, columnName) => {
    const reportName = columnName === 'licenseId' ? 'licenses' : props.reportName;
    const pathname = getNewReportPathname(props.partnerId, reportName, false, '');
    const search = getNewSearch(_objectSpread(_objectSpread({}, props.queryParams), {}, {
      offset: '0'
    }), queryParam, value);
    return pathname + search;
  };
  const fireEvent = (queryParam, value) => {
    fireAnalyticsEvent(tableDataAnalyticsConfig({
      partnerId: props.partnerId,
      reportName: props.reportName,
      queryParam,
      value: value === undefined ? '' : value
    }));
  };
  const tableHeader = TransactionsReportsHeader();
  return /*#__PURE__*/React.createElement(React.Fragment, null, error && /*#__PURE__*/React.createElement(ErrorMessage, {
    error: error.error,
    status: error.status
  }), !error && /*#__PURE__*/React.createElement(TableTreeWrapper, {
    head: tableHeader,
    items: getTransactionsReportsBody((transactionsAPIResponse === null || transactionsAPIResponse === void 0 ? void 0 : transactionsAPIResponse.transactions) || [], getReportsLink, fireEvent),
    isLoading: pending,
    rowsPerPage: rowsPerPage,
    page: pageNum,
    onSetPage: page => updateQueryParams('offset', ((page - 1) * REPORTS_ROWS_PER_PAGE).toString()),
    totalRows: totalCount !== null && totalCount !== void 0 ? totalCount : 0,
    testId: "transaction-report-success"
  }));
};
export default /*#__PURE__*/React.memo(TransactionsReports, isEqual);